import { format } from 'date-fns';

import { updateObject } from './../../utils/utility';
import deal from '../actions/deal';

const initialState = {
    dealList: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listRefreshed: false,
    dealDetails: {
        countryMappingSelected: {},
        revitalizeDeal: "Not active",
        dealType: "direct",
        ctInitialQuote: [],
    },
    prevCtInitialQuotes: [],
    countryMappingList: [],
    ctInitialQuotes: [],
    countrySpecificCostMargins: [],
    isDirty: false,
    dealCreationStatus: "",
    dealOverlapStatus: "",
    customerList: [],
    customerServiceRateCardList: [],
    legalEntityList: [],
    ctInitialQuoteDetailList: [],
    formInValid: true,
    isRefreshCountryMapping: false,
};

const assetTypes = ['Laptop', 'Desktop', 'Monitor', 'Other'];

const setDealCreationStatus = (state = initialState, action) => {
    return updateObject(state, { dealCreationStatus: action.data });
}

const setDealOverlapStatus = (state = initialState, action) => {
    return updateObject(state, { dealOverlapStatus: action.data });
}

const setUserSpecificDeals = (state = initialState, action) => {
    const { dealList, totalElements, pageNumber, totalPages } = action.data;
    return updateObject(state, {
        dealList,
        totalElements,
        pageNumber,
        totalPages,
        listRefreshed: true
    });
};

const setDealDetails = (state = initialState, action) => {
    const dealDetails = action.data;
    return updateObject(state, {
        dealDetails
    });
};

const setDealDetailsData = (state = initialState, action) => {
    const { dealDetails } = action;
    return updateObject(state, { dealDetails: { ...state.dealDetails, ...dealDetails } });
};

const addCountryMappingRow = (state = initialState, action) => {
    const { defaultCountryMapingRow } = action;
    return updateObject(state, {
        countryMappingList: [...state.countryMappingList, defaultCountryMapingRow], isDirty: true
    });
};

const addAssetTypeRowsForNewCountry = (state = initialState, action) => {
    const { defaultCountryAssetRowContent } = action;
    const assetRowsToAdd = [];
    assetTypes.map(assetType => {
        assetRowsToAdd.push({ assetType, ...defaultCountryAssetRowContent });
    });
    return updateObject(state, {
        countrySpecificCostMargins: [...state.countrySpecificCostMargins, ...assetRowsToAdd], isDirty: true
    });
};

const setCountryMappingCoulmnValue = (state = initialState, action) => {
    const { columnName, columnValue, rowIndex } = action;
    const { countryMappingList } = state;
    countryMappingList[rowIndex] = { ...countryMappingList[rowIndex], [columnName]: columnValue };
    return updateObject(state, { countryMappingList, isDirty: true });
};

const autoSetCountryMappingList = (state = initialState, action) => {
    const { countryMappingList } = action;
    return updateObject(state, { countryMappingList });
};

const resetCountryMapping = (state = initialState, action) => {
    return updateObject(state, { countryMappingList: action.countryMappingList, isDirty: true });
}

const setCountryAssetCoulmnValue = (state = initialState, action) => {
    const { columnName, columnValue, rowIndex } = action;
    const { countrySpecificCostMargins } = state;
    countrySpecificCostMargins[rowIndex] = { ...countrySpecificCostMargins[rowIndex], [columnName]: columnValue };
    return updateObject(state, { countrySpecificCostMargins, isDirty: true });
};

const resetCountryMappingFieldsSpecificToRow = (state = initialState, action) => {
    const { rowIndex, defaultCountryMapingRow } = action;
    const { countryMappingList } = state;
    countryMappingList[rowIndex] = defaultCountryMapingRow;
    return updateObject(state, { countryMappingList });
};

const resetDealDetails = (state = initialState, action) => {
    return updateObject(state, {
        dealDetails: {
            countryMappingSelected: {},
            revitalizeDeal: "Not active",
            dealType: "direct"
        },
        countryMappingList: [],
        countrySpecificCostMargins: [],
        customerList: [],
        customerServiceRateCardList: [],
        legalEntityList: [],
        formInValid: true,
    });
};

const updateCountryCodeOfAllRelatedAssets = (state = initialState, action) => {
    const { previouslySelectedCountry, newlySelectedCountry, getSelectedMargin } = action;
    const { countrySpecificCostMargins } = state;
    const updatedCountrySpecificCostMargins = [];
    countrySpecificCostMargins.map(countrySpecificCostMargin => {
        if (countrySpecificCostMargin.countryCode === previouslySelectedCountry) {
            updatedCountrySpecificCostMargins.push({ ...countrySpecificCostMargin, countryCode: newlySelectedCountry, hardwareDownlift: getSelectedMargin.hardwareDownlift, logisticUplift: getSelectedMargin.logisticUplift, processingUplift: getSelectedMargin.processingUplift });
        }
        else {
            updatedCountrySpecificCostMargins.push(countrySpecificCostMargin);
        }
    });
    return updateObject(state, { countrySpecificCostMargins: updatedCountrySpecificCostMargins, isDirty: true });
};

const deleteSpecificCountryAndPaymentMapping = (state = initialState, action) => {
    const { countryCode } = action;
    const { countryMappingList } = state;
    const indexOfCountryMappingToBeDeleted = countryMappingList.findIndex(countryMapping => countryMapping.country === countryCode);
    if (indexOfCountryMappingToBeDeleted !== -1) {
        countryMappingList.splice(indexOfCountryMappingToBeDeleted, 1);
    }
    return updateObject(state, { countryMappingList });
};

const deleteSpecificCountryAndAssetMapping = (state = initialState, action) => {
    const { countryCode } = action;
    const { countrySpecificCostMargins } = state;
    const indexList = [];
    const updatedfCountrySpecificCostMargins = [...countrySpecificCostMargins];
    countrySpecificCostMargins.map((countrySpecificCostMargin, index) => {
        if (countrySpecificCostMargin.countryCode === countryCode) {
            indexList.push(index);
        }
    });
    if (indexList.length) {
        updatedfCountrySpecificCostMargins.splice(indexList[0], indexList.length);
    }
    return updateObject(state, { countrySpecificCostMargins: updatedfCountrySpecificCostMargins });
};

const setFormDirty = (state = initialState, action) => {
    return updateObject(state, { isDirty: action.data });
}

const setAllCustomerEntity = (state = initialState, action) => {
    return updateObject(state, {
        customerList: action.data
    });
};

const setCustomerServiceRateCardList = (state = initialState, action) => {
    return updateObject(state, {
        customerServiceRateCardList: action.data
    });
};

const setCTInitialQuoteList = (state = initialState, action) => {
    return updateObject(state, {
        ctInitialQuotes: action.data
    });
};

const setCTInitialQuoteListInDealDetails = (state = initialState, action) => {
    return updateObject(state, {
        dealDetails: { ...state.dealDetails, ctInitialQuote: action.data }
    });
};

const setCTInitialQuoteDetailList = (state = initialState, action) => {
    return updateObject(state, {
        ctInitialQuoteDetailList: action.data
    });
};

const resetCTInitialQuoteDetailList = (state = initialState, action) => {
    return updateObject(state, {
        ctInitialQuoteDetailList: action.data
    });
};

const resetCTInitialQuoteList = (state = initialState, action) => {
    return updateObject(state, {
        ctInitialQuotes: action.data
    });
}

const setCustomerEntityDetails = (state = initialState, action) => {
    const { data } = action;
    const legalEntityList = data;
    return updateObject(state, {
        legalEntityList
    });
}

const updateLegalEntityColumnValue = (state = initialState, action) => {
    let { value, columnName, legalEntityId } = action;
    const { legalEntityList } = state;
    const selectedLegalEntity = legalEntityList.find(legalEntity => legalEntity.legalEntityId === legalEntityId);
    const selectedLegalEntityIndex = legalEntityList.findIndex(legalEntity => legalEntity.legalEntityId === legalEntityId);
    if (selectedLegalEntity) {
        selectedLegalEntity[columnName] = value;
        legalEntityList[selectedLegalEntityIndex] = selectedLegalEntity;
    }
    return updateObject(state, { legalEntityList });
}

const updateCTQuoteDetailsColumnValue = (state = initialState, action) => {
    let { value, columnName, quoteId, index } = action;
    const { ctInitialQuoteDetailList } = state;
    const selectedQuote = ctInitialQuoteDetailList[index];
    selectedQuote[columnName] = value;
    ctInitialQuoteDetailList[index] = selectedQuote;
    return updateObject(state, { ctInitialQuoteDetailList });
}

const setFormInvalid = (state = initialState, action) => {
    return updateObject(state, { formInValid: action.data });
}

const prevQuoteSelection = (state = initialState, action) => {
    return updateObject(state, { prevCtInitialQuotes: action.data });
}

const resetCountrySpecificMarginList = (state = initialState, action) => {
    return updateObject(state, { countrySpecificCostMargins: action.data });
}



const reducer = (state = initialState, action) => {
    if (action.type === "SET_USER_SPECIFIC_DEALS") {
        return setUserSpecificDeals(state, action);
    }
    else if (action.type === "SET_DEAL_DETAILS") {
        return setDealDetails(state, action);
    }
    else if (action.type === "SET_DEAL_DETAILS_DATA") {
        return setDealDetailsData(state, action);
    }
    else if (action.type === "ADD_COUNTRY_MAPPING_ROW") {
        return addCountryMappingRow(state, action);
    }
    else if (action.type === "ADD_ASSET_TYPE_ROWS_FOR_NEW_COUNTRY") {
        return addAssetTypeRowsForNewCountry(state, action);
    }
    else if (action.type === "SET_COUNTRY_MAPPING_COLUMN_VALUE") {
        return setCountryMappingCoulmnValue(state, action);
    }
    else if (action.type === "AUTO_SET_COUNTRY_MAPPING_LIST") {
        return autoSetCountryMappingList(state, action);
    }
    else if (action.type === "RESET_COUNTRY_MAPPING") {
        return resetCountryMapping(state, action);
    }
    else if (action.type === "SET_COUNTRY_ASSET_COLUMN_VALUE") {
        return setCountryAssetCoulmnValue(state, action);
    }
    else if (action.type === "RESET_COUNTRY_MAPPING_FIELDS_SPECIFIC_TO_ROW") {
        return resetCountryMappingFieldsSpecificToRow(state, action);
    }
    else if (action.type === "RESET_DEAL_DETAILS_DATA") {
        return resetDealDetails(state, action);
    }
    else if (action.type === "UPDATE_COUNTRY_CODE_OF_ALL_RELATED_ASSETS") {
        return updateCountryCodeOfAllRelatedAssets(state, action);
    }
    else if (action.type === "DELETE_SPECIFC_COUNTRY_AND_PAYMENT_MAPPING") {
        return deleteSpecificCountryAndPaymentMapping(state, action);
    }
    else if (action.type === "DELETE_SPECIFC_COUNTRY_AND_ASSET_MAPPING") {
        return deleteSpecificCountryAndAssetMapping(state, action);
    }
    else if (action.type === "SET_FORM_DIRTY") {
        return setFormDirty(state, action);
    }
    else if (action.type === "SET_DEAL_CREATION_STATUS") {
        return setDealCreationStatus(state, action);
    }
    else if (action.type === "SET_DEAL_OVERLAP_STATUS") {
        return setDealOverlapStatus(state, action);
    }
    else if (action.type === "SET_CUSTOMER_ENTITY_LIST") {
        return setAllCustomerEntity(state, action);
    }
    else if (action.type === "SET_CUSTOMER_SERVICE_RATECARD_LIST") {
        return setCustomerServiceRateCardList(state, action);
    }
    else if (action.type === "SET_CT_INITIAL_QUOTE_LIST") {
        return setCTInitialQuoteList(state, action);
    }
    else if (action.type === "SET_CT_INITIAL_QUOTE_LIST_FOR_DEAL_DETAILS") {
        return setCTInitialQuoteListInDealDetails(state, action);
    }
    else if (action.type === "SET_CT_INITIAL_QUOTE_DETAIL_LIST") {
        return setCTInitialQuoteDetailList(state, action);
    }
    else if (action.type === "RESET_CT_INITIAL_QUOTE_LIST") {
        return resetCTInitialQuoteList(state, action);
    }
    else if(action.type === "RESET_CT_INITIAL_QUOTE_DETAIL_LIST") {
        return resetCTInitialQuoteDetailList(state, action);
    }
    else if (action.type === "SET_LEGAL_ENTITY_DETAILS") {
        return setCustomerEntityDetails(state, action);
    }
    else if (action.type === "UPDATE_LEGALENTITY_COLUMN_VALUE") {
        return updateLegalEntityColumnValue(state, action);
    }
    else if (action.type === "UPDATE_CT_QUOTE_DETAILS_COLUMN_VALUE") {
        return updateCTQuoteDetailsColumnValue(state, action);
    }
    else if (action.type === "SET_FORM_INVALID") {
        return setFormInvalid(state, action);
    }
    else if (action.type === "PREV_QUOTE_SELECTION") {
        return prevQuoteSelection(state, action);
    }
    else if (action.type === "IS_REFRESH_COUNTRY_MAPPING") {
        return updateObject(state, { isRefreshCountryMapping: action.data });
    }
    else if(action.type === "RESET_COUNTRY_SPECIFIC_MARGIN_LIST") {
        return resetCountrySpecificMarginList(state, action);
    }
    return state;
};

export default reducer;